import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/src/app/context/useAuth';
import NotAuthorizedPage from '@/src/pages/_routing/NotAuthorizedPage';
import { Loading } from '@/src/ui';

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowedRoles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <Loading />;
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    const userHasAccess = allowedRoles && allowedRoles.includes(user.role ?? '');
    if (!userHasAccess) {
        return <NotAuthorizedPage />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
